// Default
import '../../custom/js/default';

//// JS
//import '../../custom/js/indexOptimized';
//import 'bootstrap/js/dist/dropdown';

//// Base SCSS
//import '../../custom/scss/style.scss';
import '../../custom/scss/base/form/_parent-child-select.scss';